import CheckPermissions from './CheckPermissions';
import type { CheckPermissionsProps } from './CheckPermissions.types';

export type { CheckPermissionsProps };

export { CheckPermissions };
export default CheckPermissions;
